import { Box, Button, Flex, FormControl, FormLabel, Heading, Link, Spinner, Tab, TabList, TabPanel, TabPanels, Tabs, Text, Textarea, VStack, useToast } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { TARM_AWS_URL } from '../../api/api';
import axios from 'axios';
import PrecannedQueries from './PrecannedQueries';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Link as ReachLink } from "react-router-dom";
import NLP2SQL from './NLP2SQL';
import SQLQuery from './SQLQuery';
import { Link as RouterLink } from "react-router-dom";

const GenAISearchHome = () => {
  const navOptions = [
    {
      name: "NLP to SQL",
      link: "nlp-to-sql",
      description: "Converts english sentences to SQL query using TARM GenAI"
    },
    {
      name: "SQL",
      link: "sql",
      description: "Directly write your SQL queries"
    }
  ];
  const [source] = useState(axios.CancelToken.source());
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [downloadLink, setDownloadLink] = useState('')
  const [filename, setFileName] = useState('')
  const [query, setQuery] = useState('')
  const toast = useToast();

  const handleNLP2SQL = (e) => {
    e.preventDefault();
    console.log(query)
    if (downloadLink) setDownloadLink('')
    genaiSearchHandler(query)
  }

  const handleSQL = (e) => {
    e.preventDefault();
    console.log(query)
    if (downloadLink) setDownloadLink('')
    sqlQueryHandler(query)
  };

  const sqlQueryHandler = async (sql) => {
    try {
      setIsBtnLoading(true)
      const response = await TARM_AWS_URL.post("execute-sql", {
        sql_query: query,
      },
        {
          cancelToken: source.token,
        })
      console.log(response)
      if (response.status == 200) {
        const link = response.data.presigned_url
        const filename = response.data.filename
        setFileName(filename)
        setDownloadLink(link)
      }
    } catch (error) {
      console.error(error)
      toast({
        title: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsBtnLoading(false)
    }
  }


  const genaiSearchHandler = async (query) => {
    try {
      setIsBtnLoading(true)
      const response = await TARM_AWS_URL.post("genai-search", {
        query: query,
      },
        {
          cancelToken: source.token,
        })
      console.log(response)
      if (response.status == 200) {
        const link = response.data.presigned_url
        const filename = response.data.filename
        setFileName(filename)
        setDownloadLink(link)
      }
    } catch (error) {
      console.error(error)
      toast({
        title: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsBtnLoading(false)
    }
  }

  useEffect(() => {
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, []);

  return (
    <VStack>
      <Heading>AI Search</Heading>
      <br />
      <br />

      <Flex minWidth="max-content" alignItems="center" gap="4">
        {navOptions.map((option, index) => (
          <Link as={RouterLink} to={`${option.link}`} key={index}>
            <Box
              className="box-link"
              p="4"
              borderWidth="1px"
              textAlign="center"
              borderRadius="lg"
              height="200"
              width="300px"
            >
              <br />
              <Text fontSize="2xl">{option.name}</Text>
              <br />
              <Text fontSize="sm">{option.description}</Text>
            </Box>
          </Link>
        ))}
      </Flex>
      {/* <Tabs width="70vw">
      <TabList>
        <Tab>NLP to SQL </Tab>
        <Tab>SQL</Tab>
      </TabList>

      <TabPanels>
        <TabPanel>
          <NLP2SQL handleSubmit={handleNLP2SQL} isBtnLoading={isBtnLoading} query={query} setQuery={setQuery} downloadLink={downloadLink} filename={filename} />
        </TabPanel>
        <TabPanel>
          <SQLQuery handleSubmit={handleSQL} isBtnLoading={isBtnLoading} query={query} setQuery={setQuery} downloadLink={downloadLink} filename={filename} />
        </TabPanel>
      </TabPanels>
    </Tabs> */}
      {/* <Box width="55%" borderWidth="3px" borderRadius="lg" p="10">
        <form onSubmit={handleSubmit}>
          <FormControl isRequired>
            <FormLabel>Drop your query and we will fetch all the maching results using TARM AI</FormLabel>
            <Textarea
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder='Start writing your query here...'
              resize="vertical"
              height={40}
              mt={2}
            />
          </FormControl>
          <Box textAlign="end" mt="4">
            <Button
              type="submit"
              colorScheme="blue"
              disabled={!query || isBtnLoading}
            >
              {isBtnLoading && <Spinner size="sm" mr={2} />}
              Submit
            </Button>
          </Box>
        </form>
        <Box textAlign="center">
          {
            downloadLink &&
            <Box>
              <Text>Download results: </Text>
              <Link color='blue.500' href={downloadLink}>
                {filename}
              </Link>
              <br />
              <Link
                color='blue.500'
                as={ReachLink}
                to={
                  '/home/gen-ai/grid/' + filename
                }
                isExternal
              >
                View results in grid
                <ExternalLinkIcon mx="5px" />
              </Link>
            </Box>
          }
        </Box>
      </Box>
      <PrecannedQueries /> */}
    </VStack>
  )
}

export default GenAISearchHome